import type { FaireProductEntity } from "../../entity_types/product";

export const p_zejtpshnnb: FaireProductEntity = {
  token: "p_zejtpshnnb",
  type: "product",
  name: "Spicy Satsuma Jam",
  brandToken: "b_eorgcmf04w",
  brandName: "Jamboree Jams",
  imageUrl:
    "https://cdn.faire.com/fastly/368f4697f876e57b041028bb8ace98b23f3ea1d9ffc19c1e4b6eb64f6591dd31.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df37b606f9189b38410221cc26e2a17834cc01e0ee2d49a218cd16087dde0610.jpeg",
  ],
  priceDollars: 9,
  description:
    "This spicy satsuma jam is our best seller for a reason. Pair this jam with manchego, smoked fish, smoked sausage, or as a barbecue glaze.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:30.981Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
